import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toggleLocale } from '../redux/actions';

class LocaleToggle extends Component {

    render() {
        return (
            <a className="locale-toggle" onClick={this.props.toggleLocale} > {this.props.otherLocale} </a>
        )
    }

}


const mapStateToProps = ({currentLocale}) => {
    return {
        otherLocale: ( currentLocale === "en" ? "FR" : "EN" )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        toggleLocale: () => { dispatch(toggleLocale()) }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LocaleToggle);


/** WEBPACK FOOTER **
 ** ./src/components/LocaleToggle.jsx
 **/